import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { CapsuleContainerWidgetState } from 'widgets/tiles/store/CapsuleContainerWidgetState';
import {
    buildTilesConfigSlice,
    TilesConfigPayloadType,
} from 'widgets/tiles/store/config/configSlice';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';

const { reducer: configReducer } = buildTilesConfigSlice();

const widgetStateReducer = combineReducers<CapsuleContainerWidgetState>({
    config: configReducer,
});

export const tilesWidgetsReducer = createWidgetsReducer<
    CapsuleContainerWidgetState,
    TilesConfigPayloadType
>(WidgetType.TILES, widgetStateReducer);
